document.addEventListener('DOMContentLoaded', function() {
  const productGrid = document.querySelector('#product-grid');
  const paginationWrapper = document.querySelector('.pagination-wrapper');
  
  if (!productGrid) return;

  // Initial next page URL from the hidden link we added
  let nextPageLink = document.querySelector('.pagination-next-link');
  let nextPageUrl = nextPageLink ? nextPageLink.href : null;
  
  let isLoading = false;

  // Create loading spinner
  const loader = document.createElement('div');
  loader.className = 'infinite-scroll-loader';
  loader.innerHTML = '<div class="spinner"></div>';
  loader.style.display = 'none';
  
  // Append loader after the grid
  productGrid.parentNode.appendChild(loader);

  const handleInfiniteScroll = async () => {
    // Check if we have a next page and aren't already loading
    if (isLoading || !nextPageUrl) return;

    // Calculate scroll position
    const scrollPosition = window.innerHeight + window.scrollY;
    const bodyHeight = document.body.offsetHeight;
    const threshold = 1000; // Load when within 1000px of bottom

    if (bodyHeight - scrollPosition <= threshold) {
      isLoading = true;
      loader.style.display = 'flex';

      try {
        const response = await fetch(nextPageUrl);
        const text = await response.text();
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(text, 'text/html');
        
        // Find new products
        const newProducts = newDocument.querySelectorAll('.collection-products .product-card-wrapper');
        
        // Find next page link in the new document
        const newNextLink = newDocument.querySelector('.pagination-next-link');
        
        // Append new products to the grid
        if (newProducts.length > 0) {
          newProducts.forEach(product => {
            productGrid.appendChild(product);
          });
          
          // Update URL for next fetch
          nextPageUrl = newNextLink ? newNextLink.href : null;
        } else {
          nextPageUrl = null;
        }

      } catch (error) {
        console.error('Error loading products:', error);
      } finally {
        isLoading = false;
        loader.style.display = 'none';
        
        // If no more pages, hide loader permanently
        if (!nextPageUrl) {
          loader.remove();
        }
      }
    }
  };

  // Debounce scroll event for performance
  let timeout;
  window.addEventListener('scroll', () => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(handleInfiniteScroll, 100);
  });
  
  // Check once on load in case content is short
  handleInfiniteScroll();
});
